var GameScenes = {
    Results: 'Results',
    Bets: 'Bets',
    Game: '',
    Statistics: 'Statistics',
    Info: 'Info',
    Chat: 'Chat',
};
var GameSceneCode = {
    Results: 0,
    Bets: 1,
    Statistics: 2,
    Info: 3,
    Chat: 4,
};

export { GameSceneCode, GameScenes };
